import { useAuthentication } from '@givebacks/api';
import { Outlet, useLocation } from 'react-router-dom';
import { LoadingOverlay } from 'ui';

import { NavigateToAuth } from '../../../components/molecules/NavigateToAuth';
import { useStandardLayout } from './StandardLayout';

export const AuthenticatedLayout = () => {
  const context = useStandardLayout();
  const { isAuthenticated, isLoading } = useAuthentication();
  const location = useLocation();

  if (isLoading) {
    return <LoadingOverlay visible />;
  }

  if (!isAuthenticated) {
    return <NavigateToAuth page="sign-in" redirect={location.pathname} />;
  }
  return <Outlet context={{ ...context }} />;
};
